import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import { UserProvider } from '@fff-web/fff-utilities';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { createInstance, OptimizelyProvider } from '@optimizely/react-sdk';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import env from './utils/env';
import { getOptimizelyUUID } from './utils/Optimizely';
import { initializeDDLogs, initializeDDRum } from './utils/datadog';

globalThis.window.FFF = { ...globalThis.window.FFF };
globalThis.window.FFF[process.env.APP_NAME] = {
  version: process.env.APP_VERSION,
  libs: process.env.APP_LIBS,
};

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: env.ldId,
    context: {
      kind: 'user',
      key: 'anonymous',
    },
  });

  const tagManagerArgs = {
    gtmId: env.gtmContainerId,
  };
  TagManager.initialize(tagManagerArgs);

  const optimizely = createInstance({
    sdkKey: env.optimizelyId,
  });

  ReactDOM.render(
    <React.StrictMode>
      <LDProvider>
        <OptimizelyProvider
          optimizely={optimizely}
          user={{ id: getOptimizelyUUID() }}
        >
          <UserProvider>
            <App />
          </UserProvider>
        </OptimizelyProvider>
      </LDProvider>
    </React.StrictMode>,
    document.getElementById('root'),
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
